import React, { useContext, useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Navigate, useLocation } from "react-router";
import { UpgradePlan } from "../../Pages/Settings/AccountAndBilling/UpgradePlan";
import { AuthContext } from "../../../Context/AuthContext";
import { checkIfPlanExpired } from "../../../Context/TrialPlanChecker";
import { getDateFormatOnly } from "../../../Utils/CurrentSetting";
import { currentDateObject, getDateformat } from "../../../Utils/EqupTimezone";
import { getCompanySettings } from "../../../Utils/UserUtils";

export const IsTrialExpired = () => {
  const { t: locale } = useTranslation();
  const { pathname } = useLocation();
  const [show, setShow] = useState(false);
  const [redirectTo, setRedirectTo] = useState(false);
  const { userData } = useContext(AuthContext);
  const [showModal, setShowModal] = useState(false);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [planData, setPlanData] = useState(null);
  const [currentCompanySetting, setCurrentCompanySetting] = useState({});
  const [futureMonth, setFutureMonth] = useState(null);
  const planType = "monthly";
  const [selectedPlanPrice, setSelectedPlanPrice] = useState(null);
  const upgradePlanSubscription = () => {};

  useEffect(() => {
    if (userData?.authData) {
      setPlanData(userData?.authData?.subscription || null);
    }
  }, [userData]);

  useEffect(() => {
    setCurrentCompanySetting(getCompanySettings(userData) || {});
  }, [userData]);

  useEffect(() => {
    if (currentCompanySetting) {
      const currentDate = currentDateObject().format();
      const fType = planType === "yearly" ? "Y" : "M";
      setFutureMonth(
        getDateFormatOnly(
          currentCompanySetting,
          getDateformat(currentDate).add(1, fType),
        ),
      );
    }
  }, [planType, currentCompanySetting]);

  useEffect(() => {
    if (planData && planData.price !== null && planData.price !== undefined) {
      const priceValue = Number(planData.price);
      setSelectedPlanPrice(
        Number.isFinite(priceValue)
          ? { monthly_price: priceValue, yearly_price: priceValue }
          : null,
      );
    } else {
      setSelectedPlanPrice(null);
    }
  }, [planData]);

  useEffect(() => {
    if (planData !== null) {
      if (checkIfPlanExpired(planData) || !planData.status) {
        console.log("planData:", planData);
        if (!planData?.subscription_id) {
          setRedirectTo(true);
        } else if (
          planData?.subscription_id &&
          pathname !== "/settings/accounts-and-billing"
        ) {
          setShowModal(true);
          setShowUpgradeModal(true);
        }
      } else if (
        planData?.subscription_id &&
        planData?.payment_status === "failed" &&
        pathname !== "/settings/accounts-and-billing"
      ) {
        setShow(true);
      }
    }
  }, [planData]);

  const closePopup = () => {
    setShow(false);
  };

  /******/
  if (redirectTo) {
    return <Navigate to={"/settings/accounts-and-billing"} />;
  }

  if (showUpgradeModal)
    return (
      <Modal
        className={"common modalXl edit-columns-modal"}
        onHide={() => {
          setShow(true);
          setShowUpgradeModal(false);
        }}
        show={showModal}
        backdrop={"static"}
        keyboard={false}
      >
        <Modal.Header className={"bg-primary"}>
          <Modal.Title className={"text-white secondary-font text-uppercase"}>
            {locale("pages:setting.account.plan.Upgrade Plan")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <UpgradePlan
            subscriptionId={planData?.subscription_id || ""}
            locale={locale}
            upgradeToPlan={null}
            subscribedPlan={planData}
            selectedPlanPrice={selectedPlanPrice}
            futureMonth={futureMonth}
            planType={planType}
            upgradePlanSubscription={upgradePlanSubscription}
            upgradeError={null}
            currentCompanySetting={currentCompanySetting}
          />
        </Modal.Body>
      </Modal>
    );

  if (
    planData?.payment_status === "failed" &&
    pathname !== "/settings/accounts-and-billing"
  )
    return (
      <Modal
        show={show}
        onHide={closePopup}
        centered
        style={{ zIndex: 9999 }}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className={"bg-primary"}>
          <Modal.Title className={"text-white text-uppercase"}>
            {locale("Notification")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <h4>
              Your payment has failed. Please retry to continue subscription.
            </h4>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={() => {
              setRedirectTo(true);
            }}
          >
            Retry Payment
          </Button>
        </Modal.Footer>
      </Modal>
    );

  return null;
};
